import { IS_NODE } from "@/__main__/constants.mjs";

// eslint-disable-next-line
if (!IS_NODE && globalThis.window?.self !== globalThis.window?.top) {
  throw new Error("Refusing to run in a frame!");
}
